import { useEffect } from 'react';
import { queryClient } from '@/lib/queryClient';
import { isOfflineError } from '@/lib/api';
import { useToast } from '@/components/ui/toast';

export function OfflineToastBridge() {
  const { show } = useToast();

  useEffect(() => {
    const unsubscribe = queryClient.getMutationCache().subscribe((event) => {
      if (event.type === 'updated' && event.action.type === 'error') {
        if (isOfflineError(event.action.error)) {
          show({
            title: 'Sem conexão',
            description: 'Tente novamente quando estiver online.',
            variant: 'error',
          });
        }
      }
    });
    return () => unsubscribe();
  }, [show]);

  return null;
}
